import { Type } from 'class-transformer';
import { BaseEntityWithSoftDelete } from '@models';
import { CarListBand } from '../car-list-band';
import { Site } from '../site';
import { Organization } from '../organization';
import { CarModel } from '../car-model';
import { ParkArea } from '../park-area';
import { DriverHabit } from './driver-habit.enum';
import { DriverUsage } from './driver-usage.enum';
import { FinancingType } from './financing-type.enum';
import { FuelType } from './fuel-type.enum';
import { VehicleStatus } from './vehicle-status.enum';
import { FleetVehicleValidationMetadata } from './fleet-vehicle-validation-metadata.class';
import { FleetVehicleFieldStatus } from './fleet-vehicle-field-status.enum';
import { ParkingTimeSlot } from './parking-time-slot.enum';
import { DaysOfUsage } from './days-of-usage.enum';
import { ParkingType } from './parking-type.enum';
import { ChargerInstallationStatus } from './charger-installation-status.enum';
import { ChargerInstallationPermit } from './charger-installation-permit.enum';
import { EVPreference } from './ev-preference.enum';

export class FleetVehicle extends BaseEntityWithSoftDelete {
	organizationId: string;

	@Type(() => Organization)
	organization: Organization;

	plateNumber?: string;
	vehicleStatus: VehicleStatus;
	carModelId: number;

	@Type(() => CarModel)
	carModel: CarModel;

	brand: string; // TODO: not used for displaying
	model: string; // TODO: not used for displaying
	version: string; // TODO: not used for displaying
	fuelType: FuelType;
	driverAssigned: boolean;
	driverUsage: DriverUsage;
	driverName?: string;
	driverSurname?: string;
	driverEmail?: string;
	siteId: string;

	@Type(() => Site)
	site?: Site;

	segmentId: string;

	@Type(() => CarListBand)
	segment?: CarListBand;

	financingType: FinancingType;
	otherDetails: Maybe<string>;
	taskId: string;

	@Type(() => Date)
	leasingStartDate: Maybe<Date>;
	leasingDuration: Maybe<number>;
	leasingDistance: Maybe<number>;
	leasingPrice: number;

	@Type(() => Date)
	registrationDate: Maybe<Date>;

	totalKmYear: number;
	averageKmDaily: number;
	longestTripWeekly: number;
	driverHabit: DriverHabit;
	daysOfUsage: DaysOfUsage[];
	parkingTimeSlot: ParkingTimeSlot;
	parkingDurationMins: number;
	parkingType: ParkingType;
	parkAreaId: string;
	chargerInstallationStatus: Maybe<ChargerInstallationStatus>;
	chargerInstallationPermit: Maybe<ChargerInstallationPermit>;
	evPreferences: Maybe<EVPreference>;

	@Type(() => ParkArea)
	parkArea?: ParkArea;

	moreInfo: Record<string, any>;
	selectedCarModelId: number;

	@Type(() => CarModel)
	selectedCarModel: CarModel;

	selectedBy: string;
	monthlyRate: number;
	totalCostOfOwnership: number;
	co2Emission: number;
	yearlyFuelCost: number;

	@Type(() => FleetVehicleValidationMetadata)
	validationMetaData: FleetVehicleValidationMetadata[];

	get metadataErrorFields() {
		if (this.vehicleStatus === VehicleStatus.IN_ERROR) {
			return this.validationMetaData?.filter((metadata) => metadata?.status === FleetVehicleFieldStatus.ERROR) || [];
		} else {
			return [];
		}
	}

	get metadataRequiredFields() {
		if (this.vehicleStatus === VehicleStatus.MISSING_MANDATORY_DATA) {
			return this.validationMetaData?.filter((metadata) => metadata?.status === FleetVehicleFieldStatus.REQUIRED) || [];
		} else {
			return [];
		}
	}

	get metadateMissingFields() {
		if (this.vehicleStatus === VehicleStatus.PENDING) {
			return this.validationMetaData?.filter((metadata) => metadata?.status === FleetVehicleFieldStatus.MISSING) || [];
		} else {
			return [];
		}
	}
}
